import React, { useContext, useEffect, useState } from 'react'
import videojs from 'video.js'
import 'videojs-contrib-ads/dist/videojs-contrib-ads.css'
import qualityLevels from 'videojs-contrib-quality-levels'
import hlsQualitySelector from 'videojs-hls-quality-selector'
import './videoJsStyle.css'
import './customVideoJs.css'
import ads from 'videojs-contrib-ads'
// import { AdSecondsConvert, getAdUrl } from '../../utils/helper'
// import { AppContext } from '../../context/app'
import { isEmpty } from 'lodash'
import { useInterval } from '../../hooks/useInterval'
// import { convertVideoSecondstoMintues } from './playerHelper'
import { isMobile } from 'react-device-detect'
// import SeekBar from './controlBarComponents/seekbar'
// import VolumeBar from './controlBarComponents/volumeBar'
// import PlayMenu from './controlBarComponents/playMenu'
// import SettingBar from './controlBarComponents/settingBar'
import HeaderBar from './headerBar/headerBar'
import DisplayControls from './screenComponents/displayControls'
import PlayerLogo from './screenComponents/playerLogo'
import PlayerWatermark from './screenComponents/playerWatermark'
import { useTranslation } from 'react-i18next'
import { AdSecondsConvert, captureGAEvent, getImage } from '../../utils/helper'
import SkipIcon from '../../assets/skip-ad-arrow.svg'
import NonLinearCloseIcon from '../../assets/non-linear-ad-close.svg'
import useAdvertisementHook from './advertisementHook'
import ControlBarHome from './controlBarHome'
import { AppContext } from '../../context/app'
import TipButtonsBar from './tipButtonsBar'
import CustomImage from '../customImage/customImage'
import useAxios from 'axios-hooks'
import { LIVE_ADHOC_AD_API } from '../../utils/apiUrls'
import { useParams } from 'react-router'
import AdhocAdPlayer from './adhocAdPlayer'

const CustomizedVideoJs = (props) => {
  const { t } = useTranslation()
  const contentId = useParams().contentId
  const {
    options,
    onReady,
    controlBar,
    adSetData,
    playerData,
    contentInfo,
    handleNext = null,
    handlePrev = null,
    stillWatchingAllowed = false,
  } = props

  const {
    accountObj,
    setOpenAreYouStillWatching,
    lastMouseMovedSec,
    userObj,
    setLastMouseMovedSec,
  } = useContext(AppContext)

  const stillWatchingActivated = accountObj?.od_resource_allowances?.activate_still_watching
  const stillWatchingTime = accountObj?.od_resource_allowances?.still_watching_time
  const isAdhocAdBreakAllowed = accountObj?.od_resource_allowances?.is_adhoc_ad_break_enabled

  const videoRef = React.useRef(null)
  const playerRef = React.useRef(null)

  const [showSettingMenu, setShowSettingMenu] = useState(false)

  const {
    playPreRoll,
    playMidRoll,
    playPostRoll,
    playCustomRoll,
    currentPlayingAd,
    getStyleValue,
    handleRedirect,
    positionConfig,
    handleSkip,
    adDuration,
    skipSeconds,
    handleAdEventCall,
  } = useAdvertisementHook()

  const [duration, setDuration] = useState(null)
  const [currentTime, setCurrentTime] = useState(null)
  const [bufferPercent, setBufferPercent] = useState(null)
  const [isPlaying, setIsPlaying] = useState(false)
  const [volume, setVolume] = useState(100)
  // const [isMute, setIsMute] = useState(false)
  const [isFullScreen, setIsFullScreen] = useState(false)
  const [isPIPMode, setIsPIPMode] = useState(false)
  // const [seekBarHoverPercent, setSeekBarHoverPercent] = useState(0)
  const [showControlBar, setShowControlBar] = useState(false)
  const [showDisplayIcons, setShowDisplayIcons] = useState(false)
  const [tipJarButtons, setTipJarButtons] = useState({})
  const [cursorOverControlBar, setCursorOverControlBar] = useState(false)
  const [nonLinearAds, setNonLinearAds] = useState([])
  const [currentPlayingAdhocAd, setCurrentPlayingAdhocAd] = useState({})
  const [playerStarted, setPlayerStarted] = useState(false)
  const [isMuted, setIsMuted] = useState(false)
  const [volumeLevel, setVolumeLevel] = useState(1)

  const [{ data: liveAdhocAdData, error: liveAdhocAdError }, liveAdhocAdCall] = useAxios(
    {
      url: `${LIVE_ADHOC_AD_API}/${contentId}`,
      method: 'get',
    },
    { manual: true, autoCancel: false },
  )

  useEffect(() => {
    if (!isEmpty(adSetData)) {
      setNonLinearAds(adSetData.filter((info) => info.ad_type === 'non_linear'))
    }
  }, [adSetData])

  useEffect(() => {
    if (liveAdhocAdData && liveAdhocAdData?.success) {
      const liveAdhocAdObj = liveAdhocAdData?.data
      if (!isEmpty(liveAdhocAdObj)) {
        if (liveAdhocAdObj?.ad_set_data.mode === 'STOP' && !isEmpty(currentPlayingAdhocAd)) {
          setCurrentPlayingAdhocAd({})
          if (playerRef.current) {
            playerRef.current.muted(false)
          }
          return
        }
        if (currentPlayingAdhocAd?._id !== liveAdhocAdObj?.ad_set_data?._id) {
          if (playerRef.current && playerStarted) {
            const currentMutedState = playerRef.current.muted()
            const currentVolume = playerRef.current.volume()
            playerRef.current.muted(true)
            setVolumeLevel(currentVolume)
            setIsMuted(liveAdhocAdObj?.ad_set_data.mode === 'SWITCH' ? false : currentMutedState)
            setCurrentPlayingAdhocAd(liveAdhocAdObj?.ad_set_data)
          }
        }
      }
    }
  }, [liveAdhocAdData])

  useEffect(() => {
    console.error(liveAdhocAdError)
  }, [liveAdhocAdError])

  useInterval(
    async () => {
      if (isAdhocAdBreakAllowed) {
        await liveAdhocAdCall()
      }
    },
    isAdhocAdBreakAllowed ? 1000 : null,
  )

  useEffect(() => {
    if (!isEmpty(nonLinearAds)) {
      for (let i = 0; i < nonLinearAds.length; i++) {
        const item = nonLinearAds[i]
        handleAdEventCall(item, 'IMPRESSION')
        handleAdEventCall(item, 'VIEW')
      }
    }
  }, [nonLinearAds])

  React.useEffect(() => {
    videojs.registerPlugin('qualityLevels', qualityLevels)
    videojs.registerPlugin('hlsQualitySelector', hlsQualitySelector)
    videojs.registerPlugin('ads', ads)

    let linearAds = adSetData.filter((info) => info.ad_type === 'linear')

    // make sure Video.js player is only initialized once
    if (!playerRef.current) {
      const videoElement = videoRef.current
      if (!videoElement) return
      const player = (playerRef.current = videojs(videoElement, options, () => {
        onReady && onReady(player)
        handlePlayerReady(player)
        setShowControlBar(true)
        setShowDisplayIcons(true)
        checkTipJarButton()
      }))

      // if (!isEmpty(linearAds)) {
      player.ads()
      // }

      player.on('contentchange', () => {
        player.trigger('adsready')
      })

      //   player.controls(false)

      for (let i = 0; i < linearAds.length; i++) {
        const adInfo = linearAds[i]

        // to prevent empty ads
        if (isEmpty(adInfo?.source_asset_id)) {
          continue
        }

        if (adInfo.ad_location_type === 'pre') {
          playPreRoll(adInfo, playerRef, setShowSettingMenu)
        }
        if (adInfo.ad_location_type === 'post') {
          playPostRoll(adInfo, playerRef, setShowSettingMenu)
        }
        if (adInfo.ad_location_type === 'mid') {
          playMidRoll(adInfo, playerRef, setShowSettingMenu)
        }
        if (adInfo.ad_location_type === 'custom') {
          playCustomRoll(adInfo, playerRef, setShowSettingMenu)
        }
      }

      player.trigger('adsready')
    } else {
      // you can update player here [update player through props]
      // const player = playerRef.current;
      // player.autoplay(options.autoplay);
      // player.src(options.sources);
    }
  }, [options, videoRef, adSetData])

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    const player = playerRef.current

    return () => {
      if (player) {
        player.dispose()
        playerRef.current = null
      }
    }
  }, [playerRef])

  const checkTipJarButton = () => {
    if (!isEmpty(contentInfo.custom_metadata_new)) {
      let buttons = [...contentInfo.custom_metadata_new].filter((info) => {
        let placement = info?.value?.button_data?.button_config?.placement
        return info?.type === 'button' && (placement === 'PLAYER' || placement === 'BOTH')
      })

      if (!isEmpty(buttons)) {
        setTipJarButtons(buttons.map((info) => info.value))
      }
    }
  }

  const handlePlayerReady = (player) => {
    playerRef.current = player

    player.on('waiting', () => {
      console.log('player is waiting')
    })

    player.on('ready', () => {
      player.playsinline(true)
      player.volume(localStorage.getItem('volume') ? localStorage.getItem('volume') : 1)
    })

    player.on('playing', async () => {
      if (isMobile) {
        player.requestFullscreen()
      }

      if (document.pictureInPictureElement) {
        player.requestPictureInPicture()
      }
      localStorage.setItem('volume', player.volume())
      setDuration(Math.floor(player.duration()))
      setPlayerStarted(true)
      setIsPlaying(true)
    })

    player.on('play', async () => {
      setPlayerStarted(true)
      setIsPlaying(true)
    })

    player.on('pause', async () => {
      setIsPlaying(false)
    })

    player.on('timeupdate', function () {
      setCurrentTime(Math.floor(player.currentTime()))
    })

    player.on('fullscreenchange', () => {
      if (player.isFullscreen()) {
        setIsFullScreen(true)
        return
      }
      setIsFullScreen(false)
    })

    player.on('progress', function () {
      const buffPercentage = player.bufferedPercent()
      // console.log('Buffer Percentage: ', buffPercentage * 100)
      setBufferPercent(buffPercentage * 100)
    })

    player.on('enterpictureinpicture', () => {
      setIsPIPMode(true)
    })

    player.on('leavepictureinpicture', () => {
      setIsPIPMode(false)
    })

    player.on('volumechange', () => {
      setVolume(player.volume() * 100)
      localStorage.setItem('volume', player.volume())
    })

    player.on('seeked', async () => {})

    player.on('dispose', async () => {})

    player.on('ended', async () => {})

    player.on('error', () => {})
  }

  useInterval(
    async () => {
      if (stillWatchingActivated) {
        setLastMouseMovedSec((prev) => prev + 1)
      }
    },
    stillWatchingActivated ? 1000 : null,
  )

  useInterval(
    async () => {
      setOpenAreYouStillWatching(true)
      togglePlayPause(!isPlaying)
    },
    stillWatchingAllowed &&
      stillWatchingActivated &&
      isPlaying &&
      lastMouseMovedSec >= parseInt(stillWatchingTime) * 60
      ? 1000
      : null,
  )

  const togglePlayPause = (isPlay) => {
    let player = playerRef.current

    if (!player || !isEmpty(currentPlayingAd)) {
      return
    }
    isPlay ? player.play() : player.pause()
  }

  const activatePipMode = () => {
    let player = playerRef.current
    if (!player) {
      return
    }
    player.requestPictureInPicture()
  }

  const handleKeyPress = (e) => {
    let player = playerRef.current
    if (!player) {
      return
    }
    if (e.keyCode === 39) {
      player.currentTime(player.currentTime() + 10)
    }
    if (e.keyCode === 37) {
      player.currentTime(player.currentTime() - 10)
    }

    if (e.keyCode === 38) {
      player.volume(player.volume() < 1 ? player.volume() + 0.1 : 1)
    }
    if (e.keyCode === 40) {
      player.volume(player.volume() > 0 ? player.volume() - 0.1 : 0)
    }
  }

  useInterval(
    async () => {
      if (isPlaying && !showSettingMenu && !cursorOverControlBar) {
        setShowControlBar(false)
      }
    },
    !playerData?.control_bar_always_visible && showControlBar ? 4000 : null,
  )

  useInterval(
    async () => {
      if (isPlaying && !showSettingMenu && !cursorOverControlBar) {
        setShowDisplayIcons(false)
      }
    },
    showDisplayIcons ? 4000 : null,
  )

  const forwardClick = () => {
    let player = playerRef.current
    if (!player) {
      return
    }

    player.currentTime(player.currentTime() + 10)
  }
  const backwardClick = () => {
    let player = playerRef.current
    if (!player) {
      return
    }
    player.currentTime(player.currentTime() - 10)
  }

  const handleAdRedirect = (link) => {
    handleRedirect(link)

    captureGAEvent('advertisement', 'advertisement', 'Advertisement', {
      user_id: userObj?._id || '',
      user_email: userObj?.email_id || '',
      ad_name: currentPlayingAd.name,
      campaign_id: currentPlayingAd.ad_campaign,
      content_name: contentInfo.title,
      content_id: contentInfo.content_id,
    })
    handleAdEventCall(currentPlayingAd, 'ENGAGEMENT')
  }

  const nonLinearClass = {
    TOP_LEFT: ' top-0 left-0 m-4',
    TOP_CENTER: ' top-0 left-1/2 -translate-x-1/2 mt-4',
    TOP_RIGHT: ' top-0 right-0 m-4',
    BOTTOM_LEFT: `${
      !playerData?.control_bar_always_visible && !showControlBar
        ? 'bottom-0'
        : 'bottom-[70px] md:bottom-[80px]'
    } left-0 mb-4 ml-4`,
    BOTTOM_CENTER: `${
      !playerData?.control_bar_always_visible && !showControlBar
        ? 'bottom-0'
        : 'bottom-[70px] md:bottom-[80px]'
    } left-1/2 -translate-x-1/2 mb-4`,
    BOTTOM_RIGHT: `${
      !playerData?.control_bar_always_visible && !showControlBar
        ? 'bottom-0'
        : 'bottom-[70px] md:bottom-[80px]'
    } right-0 mb-4 mr-4`,
  }

  const handleNonLinearAdClose = async (index) => {
    if (isEmpty(nonLinearAds)) return
    let temp = [...nonLinearAds]
    handleAdEventCall(nonLinearAds[index], 'ENGAGEMENT')

    temp.splice(index, 1)
    setNonLinearAds(temp)
  }

  return (
    <div
      data-vjs-player=""
      className="relative"
      onKeyDown={handleKeyPress}
      tabIndex={-1}
      onMouseMove={() => {
        setShowDisplayIcons(true)
        setShowControlBar(true)
      }}
    >
      <div
        style={{
          zIndex: !isEmpty(currentPlayingAdhocAd) ? 60 : -1,

          opacity: !isEmpty(currentPlayingAdhocAd) ? 1 : 0,
          transition: 'opacity 0.5s ease-in-out',
        }}
        className="w-full h-full absolute "
      >
        {!isEmpty(currentPlayingAdhocAd) && (
          <AdhocAdPlayer
            isMuted={isMuted}
            volumeLevel={volumeLevel}
            adInfo={currentPlayingAdhocAd}
          />
        )}
      </div>

      <div
        style={{
          //   border: '1px solid red',
          height: 'calc(100%)',
          display: !isEmpty(currentPlayingAd) ? 'flex' : 'none',
        }}
        className="w-full relative flex-col py-4 pl-4 pr-7 z-30"
      >
        {currentPlayingAd?.button?.is_enabled &&
          !currentPlayingAd?.button?.position.includes('BOTTOM') && (
            <div
              className={`w-full h-full flex ${positionConfig[currentPlayingAd?.button?.position]}`}
            >
              <button
                style={{
                  fontSize: '12px',
                  backgroundColor: getStyleValue('button_background', 'color', '#ffd91d'),
                  color: getStyleValue('button_text', 'color', '#000'),
                  fontFamily: getStyleValue('button_text', 'font', ''),
                  textAlign: getStyleValue('button_text', 'alignment', ''),
                  height: '34px',
                }}
                className={`border rounded-full px-4 ${getStyleValue(
                  'button_text',
                  'font_format',
                  '',
                )}`}
                onClick={() => handleAdRedirect(currentPlayingAd?.button?.link)}
              >
                {currentPlayingAd?.button?.text}
              </button>
            </div>
          )}
        <div
          style={{ marginTop: 'auto', fontSize: '12px' }}
          className="flex justify-between items-center relative"
        >
          {currentPlayingAd?.button?.is_enabled &&
            currentPlayingAd?.button?.position.includes('BOTTOM') && (
              <button
                style={{
                  fontSize: '12px',
                  background: '#ffd91d',
                  height: '34px',
                  zIndex: 20,
                  //   width: 'fit-content',
                  color: '#000',
                  ...positionConfig[currentPlayingAd?.button?.position],
                }}
                className={`border rounded-full px-4 absolute w-auto ${
                  currentPlayingAd?.button?.position === 'BOTTOM_RIGHT'
                    ? currentPlayingAd?.is_skip_allowed &&
                      currentPlayingAd.ad_location_type !== 'adhoc'
                      ? 'right-[100px]'
                      : 'right-0'
                    : ''
                }`}
                onClick={() => handleAdRedirect(currentPlayingAd?.button?.link)}
              >
                {currentPlayingAd?.button?.text}
              </button>
            )}
          <div className="flex items-center">
            <p className="">{`Ad `}</p>
            <div
              style={{
                width: '3px',
                height: '3px',
                background: '#fff',
                borderRadius: '12px',
                marginLeft: '3px',
                marginRight: '3px',
              }}
            />
            <p>{AdSecondsConvert(adDuration)}</p>
          </div>

          {currentPlayingAd.ad_location_type !== 'adhoc' && currentPlayingAd?.is_skip_allowed && (
            <>
              {skipSeconds > 0 ? (
                <div
                  style={{
                    background: '#00000080',
                    borderRadius: '17px',
                    fontSize: '10px',
                    height: '34px',
                  }}
                  className="px-4 flex justify-center items-center cursor-pointer"
                >
                  <p className="px-1 mr-1" style={{ borderRight: '0.5px solid #e3e3e3' }}>
                    {t('skip_after')}
                  </p>
                  <p>{skipSeconds}</p>
                </div>
              ) : (
                <div
                  style={{
                    background: '#fff',
                    borderRadius: '17px',
                    fontSize: '10px',
                    height: '34px',
                  }}
                  className="px-4 flex text-center justify-center items-center text-black cursor-pointer"
                  onClick={() => handleSkip(playerRef)}
                >
                  <p className="px-1 mr-1">{t('skip_ad')}</p>
                  <img
                    src={SkipIcon}
                    alt="SkipIcon"
                    style={{
                      width: '9.8px',
                      height: '13px',
                    }}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>

      {isEmpty(currentPlayingAd) && controlBar && duration && (
        <HeaderBar
          playerData={playerData}
          contentInfo={contentInfo}
          showDisplayIcons={showDisplayIcons}
        />
      )}
      <div
        style={{
          height: `${!showControlBar ? 'calc(100% - 56.5px)' : 'calc(100% - 102.5px)'}`,
          marginTop: !showControlBar ? '0px' : '46px',
          transition: 'all 0.25s ease-in',
        }}
        className="text-white w-full absolute top-0 z-20 flex justify-center items-center"
        onClick={() => togglePlayPause(!isPlaying)}
      >
        {controlBar ? (
          <>
            <PlayerLogo playerData={playerData} isPlaying={isPlaying} />
            <PlayerWatermark playerData={playerData} isPlaying={isPlaying} />
          </>
        ) : null}

        <DisplayControls
          isPlaying={isPlaying}
          playerData={playerData}
          forwardClick={forwardClick}
          backwardClick={backwardClick}
          showDisplayIcons={showDisplayIcons}
          isAdPlaying={!isEmpty(currentPlayingAd)}
        />
      </div>

      <video ref={videoRef} className={'video-js vjs-theme-fantasy'} />
      {!isEmpty(tipJarButtons) && isEmpty(currentPlayingAd) && controlBar && duration && (
        <TipButtonsBar
          tipJarButtons={tipJarButtons}
          activatePipMode={activatePipMode}
          bottomClass={
            !playerData?.control_bar_always_visible && !showControlBar
              ? 'bottom-0'
              : 'bottom-[70px] md:bottom-[80px]'
          }
        />
      )}

      {currentTime !== null && isEmpty(currentPlayingAd) && !isEmpty(nonLinearAds)
        ? nonLinearAds.map((item, index) => {
            return (
              <div
                style={{
                  width:
                    item.non_linear_data.type === 'WIDE' ? 'max(75%, 808px)' : 'max(45%, 480px)',
                  aspectRatio: item.non_linear_data.type === 'WIDE' ? '808 / 100' : '480 / 70',
                }}
                className={`absolute z-50 flex items-center ${
                  nonLinearClass[item.non_linear_data.position]
                }`}
                key={index}
                onClick={
                  item.button?.is_enabled ? null : () => handleAdRedirect(item?.button?.link)
                }
              >
                <CustomImage
                  imageUrl={getImage(accountObj?.cf_domain_name, item.image_s3_key)}
                  imgClass="w-full h-full"
                  loaderClass={'w-full h-full'}
                  imgAlt={`item.name`}
                />

                {item.button?.is_enabled && (
                  <div
                    className={`absolute  z-10 w-full h-full flex 
                      ${positionConfig[item?.button?.position]}
                      `}
                  >
                    <button
                      style={{
                        fontSize: '12px',
                        backgroundColor: getStyleValue(
                          'button_background',
                          'color',
                          '#ffd91d',
                          item,
                        ),
                        color: getStyleValue('button_text', 'color', '#000', item),
                        fontFamily: getStyleValue('button_text', 'font', '', item),
                        textAlign: getStyleValue('button_text', 'alignment', '', item),
                        height: '30px',
                        borderRadius: '6px',
                      }}
                      className={`px-4 ${getStyleValue(
                        'button_text',
                        'font_format',
                        'font-bold',
                        item,
                      )} mx-4`}
                      onClick={() => handleAdRedirect(item?.button?.link)}
                    >
                      {item.button?.text}
                    </button>
                  </div>
                )}
                <img
                  src={NonLinearCloseIcon}
                  alt="NonLinearCloseIcon"
                  style={{
                    margin: '5px',
                  }}
                  className="absolute top-0 right-0 cursor-pointer z-20"
                  onClick={() => {
                    handleNonLinearAdClose(index)
                  }}
                />
              </div>
            )
          })
        : null}
      {/* <TipJarButton tipJarButtons={tipJarButtons} /> */}

      {isEmpty(currentPlayingAd) && controlBar && duration && (
        <ControlBarHome
          playerEle={playerRef?.current}
          showControlBar={showControlBar}
          setCursorOverControlBar={setCursorOverControlBar}
          duration={duration}
          playerData={playerData}
          currentTime={currentTime}
          bufferPercent={bufferPercent}
          volume={volume}
          isPlaying={isPlaying}
          togglePlayPause={togglePlayPause}
          forwardClick={forwardClick}
          backwardClick={backwardClick}
          handleNext={handleNext}
          handlePrev={handlePrev}
          isPIPMode={isPIPMode}
          isFullScreen={isFullScreen}
          showSettingMenu={showSettingMenu}
          setShowSettingMenu={setShowSettingMenu}
        />
      )}
      {/* <div
        style={{
          height: showControlBar ? '56.5px' : '0px',
          // backgroundColor: '#00000080',
          transition: 'height 0.25s ease-in',
          padding: '0px 20px',
        }}
        className="text-white w-full absolute bottom-0 "
        onMouseOver={() => setCursorOverControlBar(true)}
        onMouseLeave={() => setCursorOverControlBar(false)}
      >
        <div className="parent-div relative w-full">
          <SeekBar
            handleSeek={handleSeek}
            handleSeekOver={handleSeekOver}
            convertVideoSecondstoMintues={convertVideoSecondstoMintues}
            seekBarHoverPercent={seekBarHoverPercent}
            duration={duration}
            currentTime={currentTime}
            bufferPercent={bufferPercent}
            playerData={playerData}
            showControlBar={showControlBar}
          />
        </div>
        <div className="w-full flex justify-between items-center mt-2 relative">
          <VolumeBar
            toggleMuted={toggleMuted}
            volume={volume}
            toggleVolume={toggleVolume}
            isMute={isMute}
            playerData={playerData}
          />
          <PlayMenu
            isPlaying={isPlaying}
            togglePlayPause={togglePlayPause}
            currentTime={currentTime}
            duration={duration}
            playerData={playerData}
            forwardClick={forwardClick}
            backwardClick={backwardClick}
            handleNext={handleNext}
            handlePrev={handlePrev}
          />

          <SettingBar
            playerData={playerData}
            isPIPMode={isPIPMode}
            togglePIPMode={togglePIPMode}
            isFullScreen={isFullScreen}
            toggleFullScreen={toggleFullScreen}
            showSettingMenu={showSettingMenu}
            setShowSettingMenu={setShowSettingMenu}
            playerRef={playerRef}
          />
        </div>
      </div> */}
    </div>
  )
}

export default CustomizedVideoJs
